var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:#cba07a;}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:#8a6762;}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-8);}.cls-11{fill:url(#linear-gradient-9);}.cls-12{fill:#47566a;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 40,
    y1: 127,
    x2: 40,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1a788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2d3b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 97.86,
    y1: 55,
    x2: 97.86,
    y2: 16.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 31.55,
    y1: 55,
    x2: 31.55,
    y2: 16.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 88,
    x2: 88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 64,
    y1: 73,
    x2: 64,
    y2: 38.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b756d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc9388"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 64,
    y1: 47,
    x2: 64,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbcc88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe5c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 64,
    y1: 62,
    x2: 64,
    y2: 54,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 32.5,
    y1: 95,
    x2: 32.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 95.5,
    y1: 95,
    x2: 95.5,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Empty Box") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty_Box",
    "data-name": "Empty Box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64,73v54c-1.55-.57-3.33-1.24-48-18V55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127,33,112,55,68.73,38.77,81.76,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.1,34.2c0,.11-1.6,4-1.65,4.13L16,55,1,33,46.25,16l5.48,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112,55v54c-44.67,16.76-46.45,17.43-48,18V73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62,34.41l-1.57,3.92L16,55l-2.32-3.4C66,32,58.91,34.24,62,34.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M114.32,51.6,112,55,68.73,38.77l2-3.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "112 55 64 73 16 55 60.45 38.33 68.73 38.77 112 55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "112 55 64 73 16 55 64 69 112 55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M68,47H60V42.06a16.09,16.09,0,0,1,8.67-14.21A10,10,0,1,0,54,19H46A18,18,0,1,1,72.41,34.92,8.11,8.11,0,0,0,68,42.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 64,
    cy: 58,
    r: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "64 73 64 80.11 50.54 99.85 16 86.9 16 55 64 73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "64 73 49 95 1 77 16 55 64 73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "112 55 112 86.9 77.46 99.85 64 80.11 64 73 112 55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "64 73 79 95 127 77 112 55 64 73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65,76v50.63c-1.2.44-.74.47-2,0V76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M113.24,55c15.68-23,15-21.6,14.73-22.31s2.41.49-45.31-17.41a19,19,0,0,0-37.3,0L.64,32a1,1,0,0,0-.48,1.54L14.76,55,.16,76.42A1,1,0,0,0,.64,78L15,83.33V109c0,1.06-3-.4,48.66,19a1.11,1.11,0,0,0,.72,0C116.38,108.45,113,110,113,109V83.33L127.36,78a1,1,0,0,0,.48-1.54ZM68,48a1,1,0,0,0,1-1c0-5.2-.1-5.61.3-6.92L109.09,55,64,71.91,18.91,55,59.12,39.92C58.93,41.39,59,41.82,59,47a1,1,0,0,0,1,1ZM62.06,32.33C52.73,18.65,53.51,20,54,20a1,1,0,0,0,1-1,9,9,0,1,1,13.17,8A17.45,17.45,0,0,0,62.06,32.33Zm49.55,21.43L70.21,38.23a7.41,7.41,0,0,1,2.67-2.41A18.94,18.94,0,0,0,83,17.57L125.42,33.5ZM52.68,6.35A17,17,0,1,1,71.93,34a9.12,9.12,0,0,0-5,8V46H61V42.06a15.07,15.07,0,0,1,8.12-13.31C78.72,23.68,76,9.23,65.27,8.05A11,11,0,0,0,53,18h-6A17,17,0,0,1,52.68,6.35ZM45.06,17.57C45,18,45,18.52,45,19a1,1,0,0,0,1,1h5.19L60.9,34.25a16.9,16.9,0,0,0-1.31,3.31l-43.2,16.2L2.58,33.5ZM16.39,56.24l46,17.26L48.61,93.76,2.58,76.5ZM17,84.1C50.79,96.76,48.71,96,49,96c.77,0-.32,1.27,14-19.71v49.22L17,108.29Zm94,24.19L65,125.53V76.31C79.27,97.21,78.23,96,79,96c.29,0-1.87.77,32-11.92ZM79.39,93.76,65.58,73.5l46-17.26L125.42,76.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M64,63a5,5,0,1,0-5-5A5,5,0,0,0,64,63Zm0-8a3,3,0,1,1-3,3A3,3,0,0,1,64,55Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/Empty Box.de7514f72ff8f529ce62898c302e7b89.svg";
export { ForwardRef as ReactComponent };